import { GeocoderException } from './geocoder.exception';

export class NotFoundException extends GeocoderException {}
